module.exports = __webpack_public_path__ + "static/divyarani-a38cd4383687af9385067bf0298575cd.jpg";